"use client";

import type { CSSProperties } from "react";
import { JobListWidgetEon } from "./job-list-widget-eon";

/**
 * Tokens aligned with packages/design-system/styles/globals.eon.css (:root + @theme).
 * joblist-eon uses text-primary, text-foreground, primary-hover (icon button), Load More uses bg-primary / text-primary.
 * Grid columns are @utility-based (not variables); scoped overrides below.
 */
const avaconwasserWidgetTheme = {
  "--primary": "#86bc25",
  "--primary-hover": "#D27300",
  "--primary-pressed": "#007146",
  "--primary-foreground": "oklch(1 0 0)",
  "--foreground": "#353060",
  "--ring": "#353060",
} as CSSProperties;

export function JobListWidgetAvaconwasser({
  className,
}: {
  className?: string;
}) {
  return (
    <JobListWidgetEon
      className={className}
      themeStyle={avaconwasserWidgetTheme}
    />
  );
}
